import { render, staticRenderFns } from "./HealthSummaryChips.vue?vue&type=template&id=1b515b98"
import script from "./HealthSummaryChips.vue?vue&type=script&lang=ts"
export * from "./HealthSummaryChips.vue?vue&type=script&lang=ts"
import style0 from "./HealthSummaryChips.vue?vue&type=style&index=0&id=1b515b98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports